export const environment = {
  production: false,
  apiUrl: 'https://ccn-admin.imoks.dev/api',
  clerkPublishableKey: 'pk_test_b3B0aW1hbC12aXBlci0yLmNsZXJrLmFjY291bnRzLmRldiQ',
  buildNumber: '5822',
  enableConsoleLogging: true,
  uploadDebug: true,
  uploadChunkingEnabled: true,
  uploadChunkSizeBytes: 5 * 1024 * 1024, // 5MB chunks
  highlightProjectId: '5ldwkdor',
  highlightEndpoint: 'https://whoops.imok.space/public',
  highlightOtlpEndpoint: 'https://whoops.imok.space'
};
